import { motion } from 'framer-motion'
import { duration, stagger } from '../lib/motion'
import LinkedInBadge from './LinkedInBadge'

// Shown only in Portfolio Mode. Deliberately styled as a resource shelf,
// not a download page — same card language as the rest of the site, sized
// down, so it reads as "here's everything you'd want next" rather than a
// list of file links bolted onto the bottom of a section.
const ITEMS = [
  { label: 'Case Studies', href: '#transformations', external: false },
  { label: 'About', href: '#about', external: false },
  { label: 'Contact', href: '#inquiry', external: false },
]

export default function RecruiterToolkit() {
  return (
    <section id="recruiter-toolkit" className="py-24 border-t" style={{ borderColor: 'var(--border)' }}>
      <div className="container-bw">
        <div
          className="rounded-2xl border p-8 md:p-12"
          style={{ borderColor: 'var(--border)', background: 'var(--card)' }}
        >
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
            <div>
              <p className="eyebrow mb-3">For recruiters &amp; reviewers</p>
              <h2 className="font-display text-2xl md:text-3xl" style={{ color: 'var(--text-primary)' }}>
                Everything you need in one place.
              </h2>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-start gap-x-10 gap-y-8">
            <div className="grid grid-cols-2 gap-x-6 gap-y-5">
              {ITEMS.map((item, i) => (
                <motion.a
                  key={item.label}
                  href={item.href}
                  target={item.external ? '_blank' : undefined}
                  rel={item.external ? 'noreferrer' : undefined}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-40px' }}
                  transition={{ duration: duration.base, delay: i * stagger.tight }}
                  className="text-sm font-medium underline underline-offset-4"
                  style={{ color: 'var(--text-primary)' }}
                >
                  {item.label}
                </motion.a>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: duration.base, delay: ITEMS.length * stagger.tight }}
            >
              <LinkedInBadge />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}
